<template>
  <div
    v-if="validMarkets.length"
    class="msg-market-container"
  >
    <Swiper
      ref="swiper"
      :class="{
        'multiples-swiper': validMarkets.length > 1,
        'swiper-no-swiping' : validMarkets.length <= 1
      }"
      :options="{
        slidesPerView: 'auto',
        spaceBetween: 10,
      }"
    >
      <template v-for="market in validMarkets">
        <SwiperSlide
          :key="getKey(market)"
        >
          <MsgMarket
            :market-id="Array.isArray(market)? market[0].id : market.id"
            :market="market"
            :market-name="getMarketName(market)"
            @selectVisible="onSelectVisible"
          />
        </SwiperSlide>
      </template>
    </Swiper>

    <BottomBarClose />
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import { Swiper, SwiperSlide } from 'vue-slim-swiper'
import MsgMarket from './MsgMarket'
import SlideLeftFixed from '../config/slideLeftFixed.mixin.js'
import BottomBarClose from './BottomBarClose.vue'

export default {
  name: 'MsgMarketContainer',
  components: {
    Swiper,
    SwiperSlide,
    MsgMarket,
    BottomBarClose
  },
  mixins: [SlideLeftFixed],
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const matchDetailStore = useMatchDetailStore()
    const { event, reqMarketIdsMap, currentFixedType, currentFixedId } = storeToRefs(matchDetailStore)

    const { fetchMarketsByIds } = matchDetailStore

    return {
      event,
      reqMarketIdsMap,
      currentFixedType,
      currentFixedId,
      fetchMarketsByIds
    }
  },
  data() {
    return {
      fixedLeftTime: 60,
      validMarkets: []
    }
  },
  computed: {
    showFixed() {
      return !!(this.validMarkets.length && this.fixedLeftTime && (this.currentFixedType === 0 || this.currentFixedType === 3) && this.data.isPushMsg && this.isBottom)
    },
    currentMarkets() {
      const { commentaryText } = this.data
      const { markets } = this.event
      const res = {}
      commentaryText.forEach(({ marketId }) => {
        res[marketId] = markets.map[marketId]
      })
      return res
    }
  },
  watch: {
    currentMarkets() {
      this.getValidMarkets()
      if (this.validMarkets.length > 0) {
        this.$parent.open()
      } else {
        this.timerFixed && clearInterval(this.timerFixed)
        this.$parent.close()
      }
    }
  },
  mounted() {
    const validMessage = this.data.commentaryText.filter(({ marketId }) => !this.reqMarketIdsMap[marketId])
    if (validMessage.length) {
      const ids = validMessage.map((x) => x.marketId)
      this.fetchMarketsByIds(ids).then((status) => {
        if (status) {
          this.shouldOpen()
        } else {
          this.$destroy()
        }
      })
    } else {
      this.shouldOpen()
    }
  },
  methods: {
    getKey(market) {
      return Array.isArray(market) ? market[0].id : `${market.id}_${market.specifiers}`
    },
    // 检测 market 是否可用
    checkIsActive(market) {
      if (Array.isArray(market)) {
        return market.some((x) => +x.status === 0 || +x.status === 1)
      } else {
        return +market.status === 0 || +market.status === 1
      }
    },
    getValidMarkets() {
      const { commentaryText } = this.data
      const { markets } = this.event
      const res = []
      const len = commentaryText.length
      for (let i = 0; i < len; i++) {
        const { marketId, presentationType } = commentaryText[i]
        const data = markets.map[marketId]
        if (Array.isArray(data) && (presentationType !== 1 || data.some((x) => x.outcomes && x.outcomes.order && x.outcomes.order.length > 2))) {
          data.forEach((market) => {
            if (market && this.hasOutcomes(market) && this.checkIsActive(market)) {
              res.push(market)
            }
          })
        } else if (data && this.hasOutcomes(data) && this.checkIsActive(data)) {
          res.push(data)
        }
      }
      this.validMarkets = res
    },
    shouldOpen() {
      this.getValidMarkets()
      if (this.validMarkets.length > 0) {
        this.$parent.open()
        if (this.data.isPushMsg && this.commentaryBotStatus && !this.hasNew) {
          this.judgePosition()
        }
      }
    },
    compPriority() {
      return !!(this.currentFixedType === 0 || this.currentFixedType === 3)
    },
    getMarketName(market) {
      if (Array.isArray(market)) {
        const res = market.filter((x) => x.description)
        return res && res[0].description
      } else {
        return market && market.description
      }
    },
    // 判断 market 中是否有 outcome 存在, 有可能新增 market 没有 outcomes
    hasOutcomes(market = {}) {
      if (Array.isArray(market)) {
        return market.some((x) => x.outcomes && x.outcomes.order && x.outcomes.order.length)
      } else {
        const { outcomes } = market
        return outcomes && outcomes.order && outcomes.order.length
      }
    },
    onSelectVisible(visible) {
      const swiper = this.$refs.swiper.$el
      if (visible) {
        swiper.style.overflow = 'initial'
        swiper.style.zIndex = '9'
      } else {
        swiper.style.overflow = 'hidden'
        swiper.style.zIndex = '1'
      }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.msg-market-container {
  width: 100%;
  background-color: @mask;

  &.fixed-bottom {
    position: fixed;
    z-index: 10;
    right: 0;
    bottom: 70/@rem;
    left: 0;
    width: 296/360 *100%;
    border-radius: 4px;
    margin: auto;
    box-shadow: 0 -15/@rem 30/@rem 10/@rem @dark;
    transform: translateX(-100%);

    .bottom-bar-close {
      display: flex;
    }
  }

  .multiples-swiper {
    .swiper-slide,
    .msg-market {
      width: 276/@rem;
      box-sizing: border-box;
    }
  }
}
</style>
